import React, { useState, useEffect } from "react";
import { Pagination } from 'react-bootstrap';

const itemsPerPage = 100;

export function KSGPagination(props) {
    const [activePage, setActivePage] = useState(1);
    const indexOfLastItem = activePage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    let totalPages = Math.ceil(props.totalItems / itemsPerPage);
    // let currentData = props.data ? props.data.slice(indexOfFirstItem, indexOfLastItem) : [];
    let currentData = props.data;
    let displayPagination = props.totalItems > itemsPerPage;

    useEffect(() => {
        if (totalPages < activePage)
        {
            setActivePage(1);
            props.setActivePage(1);
        }
        loadCurrentData(props);
    }, [props.data, activePage]);

    const loadCurrentData = (props) => {
        props.onData(currentData);
    };

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        props.setActivePage(pageNumber);
    };

    const handlePrevPage = () => {
        setActivePage(activePage - 1);
        props.setActivePage(activePage - 1);
    };

    const handleNextPage = () => {
        setActivePage(activePage + 1);
        props.setActivePage(activePage + 1);
    };

    const renderPaginationPages = () => {
        const maxDisplayedPages = 5;
        const startPage = Math.max(1, activePage - Math.floor(maxDisplayedPages / 2));
        const endPage = Math.min(totalPages, startPage + maxDisplayedPages - 1);
        let pages = [];

        for (let num = startPage; num <= endPage; num++) {
            pages.push(
                <Pagination.Item
                    key={num}
                    active={num === activePage}
                    onClick={() => handlePageChange(num)}
                >
                    {num}
                </Pagination.Item>
            );
        }

        if (startPage > 1) {
            pages.unshift(
                <Pagination.Ellipsis key="start-ellipsis" disabled />
            );
            pages.unshift(
                <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                    {1}
                </Pagination.Item>
            );
        }

        if (endPage < totalPages) {
            pages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
            pages.push(
                <Pagination.Item
                    key={totalPages}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return pages;
    };

    if (displayPagination)
        return (
            <Pagination className="justify-content-center">
                <Pagination.Prev onClick={handlePrevPage} disabled={activePage === 1} />
                {renderPaginationPages()}
                <Pagination.Next onClick={handleNextPage} disabled={activePage === totalPages} />
            </Pagination>
        )
};